"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.list.title': 'Branże Zawodowe',
    'branch.list.empty': 'Nie znaleziono branż',
};
